import React from "react";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {Field, Form, Formik} from "formik";
import {postContext} from "../../../redux_slices/contextSlice";
import {renewToken} from "../../../redux_slices/authenticationSlice";
import TermsAndConditionsContent from "./TermsAndConditionsContent";

const TermsAndConditionsChallenge = ({values}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onSubmitTryLogin = async (values, {resetForm}) => {
        await dispatch(
            postContext({
                challenge: "signUp",
                values,
            })
        ).then(() => dispatch(renewToken()));
    };

    return (
        <div className={"card-body"}>
            <div className="d-flex flex-column m-auto flex-center">
                <div className="login-form login-signin">
                    <Formik
                        initialValues={Object.assign({}, values, {termsAndConditions: null})}
                        onSubmit={onSubmitTryLogin}
                    >
                        {({values, errors}) => {
                            return (
                                <Form>
                                    <div className="pb-13 pt-lg-0 pt-5">
                                        <h3 className="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
                                            {t("AUTH.CHALLENGE.SIGNUP.TITLE")}
                                        </h3>
                                        <span className="text-muted font-weight-bold font-size-h4">
                                            {t("AUTH.CHALLENGE.SIGNUP.SUBTITLE")}
                                        </span>
                                    </div>
                                    <div className="form-group">
                                        <label className="font-size-h6 font-weight-bolder text-dark">
                                            {t("AUTH.CHALLENGE.SIGNUP.NAME")}
                                        </label>
                                        <Field
                                            id="name"
                                            name="name"
                                            type="text"
                                            className="form-control form-control-solid h-auto py-6 px-6 rounded-lg"
                                            autoComplete="off"
                                            placeholder={t("AUTH.CHALLENGE.SIGNUP.NAME")}
                                            autoFocus
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="font-size-h6 font-weight-bolder text-dark pt-5">
                                            {t("AUTH.CHALLENGE.SIGNUP.SURNAME")}
                                        </label>
                                        <Field
                                            id="surname"
                                            name="surname"
                                            type="text"
                                            className="form-control form-control-solid h-auto py-6 px-6 rounded-lg"
                                            autoComplete="off"
                                            placeholder={t("AUTH.CHALLENGE.SIGNUP.SURNAME")}
                                        />
                                    </div>
                                    {values.username ? (
                                        <div className="form-group">
                                            <label className="font-size-h6 font-weight-bolder text-dark pt-5">
                                                {t("AUTH.CHALLENGE.SIGNUP.EMAIL")}
                                            </label>
                                            <Field
                                                id="username"
                                                name="username"
                                                disabled
                                                type="text"
                                                className="form-control form-control-solid h-auto py-6 px-6 rounded-lg"
                                                autoComplete="off"
                                                placeholder="username"
                                            />
                                        </div>
                                    ) : null}
                                    <div className="form-group">
                                        <TermsAndConditionsContent />
                                        <div className="d-flex align-items-center agree_checkbox">
                                            <Field
                                                name={"termsAndConditions"}
                                                type="checkbox"
                                                defaultValue={false}
                                                className="form-check-input ml-1 h-40px w-40px cursor-pointer"
                                            />
                                            <label className="form-check-label ml-24 cursor-pointer" htmlFor="check">
                                                {t("TERMSCONDITIONS.AGREE")}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="pb-lg-0 pb-5">
                                        <button
                                            type="submit"
                                            disabled={!values.name || !values.surname || !values.termsAndConditions}
                                            className="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3"
                                        >
                                            {t("AUTH.CHALLENGE.SIGNUP.BUTTON")}
                                        </button>
                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                </div>
            </div>
        </div>
    );
};
export default TermsAndConditionsChallenge;
